<template>
  <div>
    <div class="home-header">
      <div class="home-back" @click="goBack()">
        <img src="../../static/image/back.png" alt="" v-if="routerName !== 'home'">
      </div>
      <div class="home-right">
        <div class="home-search" @click="searchPage()" v-if="routerName !== 'search'">
          <img src="../../static/image/search.png" alt="">
          <p>请输入搜索内容</p>
        </div>
        <!--        <div class="collect-icon" @click="pageJump('collect')">-->
        <div class="collect-icon" @click="pageCollect()">
          <img src="../../static/image/header-collect.png" alt="">
          <span class="collect-number" v-if="collectNum !== -1">{{ collectNum }}</span>
        </div>
        <div class="home-icon" @click="navDrawerFun()">
          <img src="../../static/image/nav.png" alt="">
        </div>
      </div>

    </div>
    <el-drawer
      :visible="navDrawer"
      :before-close="navDrawerFun">
      <div class="home-nav-list">
        <div class="home-nav-item" v-for="item in navList" @click="pageJump(`classify?id=${item.id}`)">
          {{ item.tagname }}
        </div>
        <!--        <div class="home-nav-item" @click="pageJump('client')">-->
        <!--          客户评价-->
        <!--        </div>-->

        <div class="home-nav-item" @click="pageJump('newProduct')">
          新品.推荐
        </div>
        <div class="home-nav-item" @click="pageJump('classification')">
          照片分类
        </div>
        <div class="home-nav-item" @click="pageJump('setMenu')">
          套餐
        </div>
        <div class="home-nav-item" @click="downImg()">下载</div>
        <div class="home-nav-item home-exit" @click="exitFun()">
          <img src="../../static/image/exit.png" alt="">
          退出
        </div>
      </div>
    </el-drawer>
    <div class="progress-box" v-if="downFlag" @click="downLoadClick">
      <div class="progress-content">
        <el-progress :text-inside="true" :stroke-width="15" :percentage="total > 0 ? parseInt((current/total)*100) :0"
                     status="warning"></el-progress>
        <div class="progress-tips">
          {{ current }}/{{ total }}
        </div>
      </div>
    </div>


    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="drawerFun">
      <div class="login-title">
        <h4>微信扫码登录</h4>
        <span>{{ `请在（${loginTime}）秒内扫码登录` }}</span>
      </div>
      <div class="login_container">
        <img :src="wxUrl" alt="">
      </div>
      <div class="login-tip">
        扫码登录后，收藏客户喜欢的照片，可以实时同步小程序
      </div>
    </el-dialog>
  </div>

</template>

<script>
let timer = null
export default {
  name: 'ComHeader',
  data () {
    return {
      dialogVisible: false,
      loginTime: 0,
      navDrawer: false,
      collectNum: -1,
      navList: [],
      routerName: '',
      downFlag: false,
      current: 0,
      total: 0,
      openid: '',
      codeData: {},
    }
  },
  computed: {
    wxUrl () {
      return `data:image/jpeg;base64,${this.codeData.base64_image_content}`
    }
  },
  beforeRouteLeave (to, form, next) {
    this.getClearTime()
    next()
  },
  mounted () {
    this.routerName = this.$route.name

    if (window.localStorage.getItem('shopInfo')) {
      this.shopInfo = JSON.parse(window.localStorage.getItem('shopInfo'))
    }

    if (window.localStorage.getItem('openid')) {
      this.openid = window.localStorage.getItem('openid')
      this.getCollect()
    }

    this.getNavList()
  },
  methods: {
    pageCollect () {
      if (!window.localStorage.getItem('openid')) {
        this.drawerFun()
      } else {
        this.pageJump('collect')
      }
    },
    drawerFun () {
      if (!this.dialogVisible) {
        this.loginTime = 90
        this.$get('/pc/shop/getUnlimit', {}).then((res) => {
          clearInterval(timer)
          timer = null
          this.codeData = res.data
          this.dialogVisible = true
          timer = setInterval(() => {
            this.loginTime--
            if (this.loginTime <= 0) {
              this.getClearTime()
            }
            this.getWxLogin()
          }, 1000)
        }).catch((error) => {

        })

      } else {
        this.getClearTime()
      }

    },
    getClearTime () {
      this.dialogVisible = !this.dialogVisible
      clearInterval(timer)
      timer = null
    },
    getWxLogin () {
      this.$get('/pc/shop/memberInfo', {scene: this.codeData.scene}).then((res) => {
        if (res.data.is_scan_login === 1) {
          window.localStorage.setItem('openid', res.data.openid)
          this.openid = res.data.openid
          this.getClearTime()
          this.loginCall()
        }
      }).catch((error) => {

      })
    },
    downLoadClick () {
      this.$message.error('资源正在加载中，请稍后！')
    },
    goBack () {
      if (this.routerName === 'home') return
      this.$router.back(-1)
    },
    exitFun () {
      // window.localStorage.removeItem('userInfo')
      // window.localStorage.removeItem('openid')
      // window.localStorage.removeItem('navList')
      // window.localStorage.removeItem('token')
      // window.localStorage.removeItem('style')
      this.pageJump('login')
    },
    pageJump (router) {
      this.$router.push(router)
    },
    getNavList () {
      this.$get('/pc/shop/secondClassify', {}).then((res) => {
        this.navList = res.data
        window.localStorage.setItem('navList', JSON.stringify(res.data))
      }).catch((error) => {
      })
    },
    getCollect () {
      this.$get('/pc/shop/myCollect', {
        size: 9,
        page: 1,
      }).then((res) => {

        this.collectNum = res.meta.total
      }).catch((error) => {

      })
    },
    navDrawerFun () {

      this.navDrawer = !this.navDrawer
    },
    searchPage () {
      this.$router.push({name: 'search'})
    },
    sleep (delay) {
      return new Promise((resolve) => setTimeout(resolve, delay))
    },
    downImg () {
      this.navDrawerFun()
      this.downFlag = true
      this.$get('/pc/shop/download', {}).then((res) => {
        let imgList = res.data
        let imgNum = 1
        this.total = res.data.length
        const creat_dom = async () => {
          for (let i = 0; i < imgList.length; i++) {
            let image = new Image()
            image.onload = (image) => {
              this.current = imgNum++
              if (this.current >= this.total) {
                this.downFlag = false
                this.$message.success('资源加载完成，请开始使用！')
              }
              image = undefined
            }
            image.onerror = (image) => {
              this.current = imgNum++
              if (this.current >= this.total) {
                this.downFlag = false
                this.$message.success('资源加载完成，请开始使用！')
              }
              image = undefined
            }
            image.src = imgList[i]
            if (i % 5 === 0) {
              await this.sleep(1000)
            }
          }
        }
        creat_dom().then(r => null)

      }).catch((error) => {
      })
    },
    downFun () {

    }
  }

}
</script>

<style scoped lang="less">
.home-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  margin: 0 80px;
  box-sizing: border-box;
}

.home-right {
  display: flex;
  align-items: center;
}

.home-search {
  display: flex;
  align-items: center;
  width: 170px;
  height: 50px;
  box-sizing: border-box;
  padding: 0 9px;
  border: 2px solid #E8B45E;
  border-radius: 8px;
}

.home-search img {
  width: 21px;
  height: 21px;
}

.home-search p {
  margin-left: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #B4B4B4;
}

.home-icon {
  width: 39px;
  height: 39px;
  margin-left: 37px;
}

.home-icon img {
  width: 100%;
  height: 100%;
}

.home-nav-list {
  background: #222222;
}

.el-drawer {
  width: 400px !important;
}

.home-nav-item {
  box-sizing: border-box;
  padding-left: 50px;
  height: 125px;
  line-height: 125px;
  border-bottom: 2px solid #393836;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
}

.home-exit {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  padding-left: 0;
}

.home-exit img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.progress-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9;
}

.progress-content {
  position: absolute;
  top: 190px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 900px;
  height: 10px;
}

.progress-tips {
  width: 100%;
  line-height: 50px;
  height: 50px;
  font-size: 24px;
  color: #000;
  text-align: center;
}

.home-back {
  display: flex;
  width: 50px;
  height: 50px;

  img {
    width: 15px;
    height: 30px;
  }
}

.login-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login-title h4 {
  line-height: 40px;
  font-size: 30px;
  font-weight: 600;
  color: #222222;
}

.login-title span {
  margin: 20px 0;
  font-size: 20px;
  font-weight: 400;
  color: #353535;
}

.login_container {
  width: 20.83vw;
  height: 20.83vw;
  margin: 30px auto;
}

.login_container img {
  width: 20.83vw;
  height: 20.83vw;
}

.login-tip {
  margin-top: 50px;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #353535;
}


</style>



// WEBPACK FOOTER //
// src/components/ComHeader.vue